import { PageHandler } from "../../../library-js/dom-tools/PageHandler";

export class DataTypesLibrary
{
  static noLinks = 
  [
    "",
    "void"
    // , 
    // "byte","short","int","long", 
    // "float", "double", 
    // "string","bool",  
  ]

  static async getDataTypeLinkFromAny( type:string, docsPath:string, pageHandler:PageHandler ):Promise<string>
  { 
    let godotPath = docsPath + "/godot/";


    let path = await this.getDataTypeLink( type, godotPath, pageHandler );

    if ( path != null )
    {
      return "../godot/" + path;
    } 

    let rokojoriPath = docsPath + "/rokojori/"; 

    path = await this.getDataTypeLink( type, rokojoriPath, pageHandler );

    if ( path != null )
    {
      return "../rokojori/" + path;
    } 

    return null;
     
  }

  static async getDataTypeLink( type:string, docsPath:string, pageHandler:PageHandler ):Promise<string>
  {   
    let triedPaths:string[] = [];
    let link = await this._getDataTypeLink( type, docsPath, pageHandler, triedPaths);

    return link;
  }

  static async _getDataTypeLink( type:string, docsPath:string, pageHandler:PageHandler, triedPaths:string[] ):Promise<string>
  {    

    type = ( type || "" ).trim();

    if ( this.noLinks.indexOf( type ) != -1 )
    {
      return Promise.resolve( null );
    }

    let pageURL = docsPath + type + "-class.php";
    triedPaths.push( pageURL );

    let page = await pageHandler.getPage( pageURL );

    if ( page == null && /^_/.test( type ) )
    {
      let noLeadingUnderscoreType = type.replace( /^_/, "" );
      pageURL = docsPath + noLeadingUnderscoreType + "-class.php";

      triedPaths.push( pageURL );
      page = await pageHandler.getPage( pageURL );

      if ( page != null )
      {
        return Promise.resolve( noLeadingUnderscoreType );
      }
    }

    if ( page == null && /\</.test( type ) )
    {
      let genericsPage = type.replace( /\<|\>/g, "-" );
      pageURL = docsPath + genericsPage + "-class.php";
      triedPaths.push( pageURL );
      page = await pageHandler.getPage( pageURL );

      if ( page != null )
      {
        return Promise.resolve( genericsPage );
      }
    }

    if ( page == null )
    {
      type = type.toLowerCase();
    }

    pageURL = docsPath + type + "-class.php";

    triedPaths.push( pageURL );
    page = await pageHandler.getPage( pageURL );

    if ( page == null )
    {
      return Promise.resolve( null );
    }

    return Promise.resolve( type );
  }
}